module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAT5JREFUOI3N1L1OAkEUhuH3zG5MgMo70ERLe7tlSYguUqloYudPYusd7DXYCjQWNvxUoJIYkZILsLPwBiilYmctXNF1FRiMiV83k8mTc85MBv5dQuTz0vqN5fu+kkGqulRazT7XnjpAXDfFemv9iogcRqWed3duz+arMERkkKp+YACyvry/sqjmwZymV4ljgCZE5NGs5QhTcJTALE672zdl2wRzm16ZCRjAuGW34eVy9YI7BTuehEF0y7l6wQ3CoAVgiVW8373uzoMBiFPbyAJtpVQaQGs9BLZ6pc4DIeI2Ni8QOZkFewMbXltBIXZe66ElVjFEH5hgAPbCy2hvlLbbCM77plIqHRDcKVT8WU3BIJph/jKf+YomMgM2BqeiM2Ix8EfUAEuACdQQ+xYcoxm7hXBlgk2M7/vmH8df5BXww5dkDkcSGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/correct.png
// module id = 200
// module chunks = 0